<div class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-slate-900/60 backdrop-blur-sm" *ngIf="formData">
  <div class="relative w-full max-w-3xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col h-[min(92vh,880px)]">

    <div *ngIf="isLoadingDetail() || isSaving()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <!-- Header -->
    <div class="flex-none px-5 md:px-8 py-4 border-b border-slate-100 dark:border-slate-800">
      <div class="flex items-start justify-between gap-4 mb-4">
        <div>
          <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">confirmation_number</span>
            {{ advanceId > 0 ? 'แก้ไขบัตรล่วงหน้า' : 'สร้างบัตรล่วงหน้า' }}
          </h3>
          <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">
            ขั้น {{ wizardStep() }}: {{ currentStepMeta.title }} — {{ currentStepMeta.hint }}
          </p>
        </div>
        <button type="button" (click)="onClose()" [disabled]="isSaving()"
          class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
          <span class="material-icons">close</span>
        </button>
      </div>

      <!-- Stepper -->
      <div class="grid grid-cols-3 gap-2">
        <button type="button" *ngFor="let s of wizardSteps" (click)="goStep(s.id)"
          class="rounded-xl border px-3 py-2 text-left transition-all"
          [ngClass]="wizardStep() === s.id
            ? 'border-amber-400 bg-amber-50 dark:bg-amber-950/30'
            : (wizardStep() > s.id ? 'border-emerald-200 bg-emerald-50/50 dark:bg-emerald-950/20' : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900')">
          <p class="text-[11px] font-bold text-slate-400">ขั้น {{ s.id }}</p>
          <p class="text-xs font-extrabold text-slate-800 dark:text-slate-100 truncate">{{ s.title }}</p>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="flex-1 min-h-0 overflow-hidden px-5 md:px-8 py-5 flex flex-col">

      <!-- Step 1: Client -->
      <div *ngIf="wizardStep() === 1" class="flex-1 min-h-0 flex flex-col gap-3">
        <div class="flex-none rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-sm text-sky-900 dark:text-sky-100">
          ค้นหาแล้วเลือกร้านจากรายการด้านล่าง — รายการยาวเลื่อนได้เต็มพื้นที่
        </div>

        <div *ngIf="isClientFieldLocked && formData.clientId"
          class="flex-none p-4 rounded-2xl border border-emerald-200 dark:border-emerald-800 bg-emerald-50/50 dark:bg-emerald-900/20">
          <div class="text-xs font-bold text-emerald-600 uppercase mb-1">ร้านที่ผูกกับบัญชี</div>
          <div class="font-bold text-emerald-900 dark:text-emerald-100 flex items-center gap-2">
            <span class="material-icons text-base">store</span>
            {{ formData.clientName || ('Client #' + formData.clientId) }}
          </div>
        </div>

        <ng-container *ngIf="!isClientFieldLocked">
          <div class="flex-none relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-lg pointer-events-none">search</span>
            <input type="text" [(ngModel)]="clientSearchText" (ngModelChange)="onClientListSearch($event)"
              [disabled]="isSaving()" placeholder="ค้นหาชื่อร้าน / บริษัท..."
              class="w-full h-[46px] pl-10 pr-4 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <p class="flex-none text-[11px] text-slate-400">
            แสดง {{ filteredClientOptions.length }} จาก {{ clients.length }} รายการ
            <span *ngIf="formData.clientId" class="text-amber-600 dark:text-amber-400 font-bold"> · เลือกแล้ว: {{ formData.clientName }}</span>
          </p>

          <div class="flex-1 min-h-0 overflow-y-auto rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 custom-scrollbar">
            <button type="button" *ngFor="let c of filteredClientOptions"
              (click)="onClientListSelect(c)" [disabled]="isSaving()"
              class="w-full text-left px-4 py-3 border-b border-slate-100 dark:border-slate-800 last:border-b-0 transition-colors"
              [ngClass]="formData.clientId === c.id
                ? 'bg-amber-50 dark:bg-amber-900/30 ring-inset ring-2 ring-amber-300'
                : 'hover:bg-white dark:hover:bg-slate-800'">
              <div class="flex items-center gap-3">
                <span class="material-icons text-lg"
                  [ngClass]="formData.clientId === c.id ? 'text-amber-500' : 'text-slate-300'">
                  {{ formData.clientId === c.id ? 'check_circle' : 'store' }}
                </span>
                <div class="min-w-0">
                  <div class="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">{{ c.name }}</div>
                  <div class="text-[11px] text-slate-400">ID {{ c.id }}</div>
                </div>
              </div>
            </button>
            <div *ngIf="filteredClientOptions.length === 0" class="px-4 py-10 text-center text-sm text-slate-400">
              ไม่พบร้านที่ตรงกับคำค้น
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Step 2: Card config -->
      <div *ngIf="wizardStep() === 2" class="flex-1 min-h-0 overflow-y-auto custom-scrollbar space-y-4">
        <div class="p-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 flex items-center gap-2 text-sm">
          <span class="material-icons text-amber-500 text-base">store</span>
          <span class="font-bold text-slate-800 dark:text-slate-100">{{ formData.clientName || ('Client #' + formData.clientId) }}</span>
          <button *ngIf="!isClientFieldLocked" type="button" (click)="goStep(1)"
            class="ml-auto text-xs font-bold text-amber-600 hover:underline">เปลี่ยนร้าน</button>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Subscription <span class="text-rose-500">*</span></label>
          <div *ngIf="isLoadingSubscriptionOptions()" class="text-sm text-slate-500 flex items-center gap-2 mb-2">
            <div class="w-4 h-4 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
            กำลังโหลดรายการ subscription...
          </div>
          <div class="max-h-48 overflow-y-auto rounded-xl border border-slate-200 dark:border-slate-700 custom-scrollbar">
            <button type="button" *ngFor="let opt of subscriptionOptions"
              (click)="selectSubscription(opt.configId)" [disabled]="isSaving() || isLoadingSubscriptionOptions()"
              class="w-full text-left px-3 py-2.5 border-b border-slate-100 dark:border-slate-800 last:border-b-0 transition-colors text-sm"
              [ngClass]="selectedConfigId === opt.configId
                ? 'bg-amber-50 dark:bg-amber-900/30 font-bold'
                : 'bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-slate-800'">
              {{ opt.subscriptionName }}
              <span *ngIf="opt.vehicleTypeName" class="text-slate-400 font-normal"> · {{ opt.vehicleTypeName }}</span>
              <span *ngIf="opt.cardTypeName" class="text-slate-400 font-normal"> · {{ opt.cardTypeName }}</span>
              <span *ngIf="opt.cardScope" class="text-slate-400 font-normal"> · {{ cardScopeLabel(opt.cardScope) }}</span>
            </button>
            <div *ngIf="!isLoadingSubscriptionOptions() && subscriptionOptions.length === 0"
              class="px-3 py-6 text-center text-sm text-slate-400">ไม่พบ Subscription</div>
          </div>
          <p class="text-[11px] text-slate-400 mt-1">Subscription จอดฟรีตาม Access Group · ประเภทรถดึงอัตโนมัติ</p>
        </div>

        <div *ngIf="formData.subscriptionId > 0"
          class="p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 text-sm">
          <div class="grid grid-cols-2 gap-3">
            <div>
              <div class="text-xs text-slate-400 font-bold uppercase mb-1">ประเภทบัตร</div>
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ formData.cardTypeName || '-' }}</div>
            </div>
            <div>
              <div class="text-xs text-slate-400 font-bold uppercase mb-1">ประเภทรถ</div>
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ formData.vehicleTypeName || '-' }}</div>
            </div>
            <div>
              <div class="text-xs text-slate-400 font-bold uppercase mb-1">ขอบเขตบัตร</div>
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ cardScopeLabel(formData.cardScope) }}</div>
            </div>
            <div>
              <div class="text-xs text-slate-400 font-bold uppercase mb-1">Subscription</div>
              <div class="font-bold text-slate-800 dark:text-slate-100">{{ formData.subscriptionName || '-' }}</div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จำนวนรหัส <span class="text-rose-500">*</span></label>
            <input type="number" min="1" max="500" [(ngModel)]="formData.qty" (input)="onQtyInput($event)" [disabled]="isSaving()"
              class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              รหัสใช้ได้ภายใน (วัน) <span class="text-rose-500">*</span>
            </label>
            <input type="number" min="1" max="365" [(ngModel)]="formData.activateExpireDays" [disabled]="isSaving()"
              class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">วันเริ่ม</label>
            <input type="date" [(ngModel)]="formData.startDate" [disabled]="isSaving()"
              class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">วันหมดอายุ</label>
            <input type="date" [(ngModel)]="formData.endDate" [disabled]="isSaving()"
              class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
          </div>
        </div>
        <p class="text-[11px] text-slate-400 -mt-2">นับจากวัน Gen · default 10 · Subscription จอดฟรี = หักโควต้าตอน activate</p>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
          <textarea rows="2" [(ngModel)]="formData.remark" [disabled]="isSaving()"
            class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
        </div>
      </div>

      <!-- Step 3: Finance + confirm -->
      <div *ngIf="wizardStep() === 3" class="flex-1 min-h-0 overflow-y-auto custom-scrollbar space-y-4">
        <div class="p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 text-sm grid grid-cols-2 gap-3">
          <div>
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">ร้าน</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ formData.clientName || '-' }}</div>
          </div>
          <div>
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">Subscription</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ formData.subscriptionName || '-' }}</div>
          </div>
          <div>
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">ประเภทรถ</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ formData.vehicleTypeName || '-' }}</div>
          </div>
          <div>
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">จำนวนรหัส</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ formData.qty }}</div>
          </div>
        </div>

        <div class="p-5 rounded-2xl border border-blue-200/70 dark:border-blue-800/50 bg-blue-50/40 dark:bg-blue-900/10 space-y-3">
          <h4 class="text-sm font-bold text-blue-800 dark:text-blue-300 flex items-center gap-2">
            <span class="material-icons text-base">receipt_long</span>
            แนบใบเสร็จ (ถ้ามี)
          </h4>
          <p class="text-[11px] text-blue-700/80 dark:text-blue-400/80">ค้นหาด้วยเลขที่ใบเสร็จ แล้วเลือกจากรายการ — ข้ามได้ถ้าไม่มี</p>

          <div class="flex gap-2">
            <input type="text" [(ngModel)]="financeReceiptSearch" placeholder="เลขที่ใบเสร็จ..."
              [disabled]="isSaving() || !!selectedFinance"
              class="flex-1 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-blue-200 font-mono">
            <button type="button" (click)="onSearchFinance()" [disabled]="isSaving() || isSearchingFinance() || !!selectedFinance"
              class="px-4 py-2 rounded-xl bg-blue-500 hover:bg-blue-600 text-white text-sm font-bold disabled:opacity-50 flex items-center gap-1">
              <span *ngIf="isSearchingFinance()" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              ค้นหา
            </button>
            <button *ngIf="selectedFinance" type="button" (click)="onClearFinance()" [disabled]="isSaving()"
              class="px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-500 hover:text-rose-500">
              ลบ
            </button>
          </div>

          <div *ngIf="selectedFinance" class="p-3 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 text-sm">
            <div class="text-xs text-emerald-600 dark:text-emerald-400 font-bold uppercase mb-1">เลือกแล้ว</div>
            <div class="font-mono font-bold text-emerald-800 dark:text-emerald-200">{{ selectedFinance.receiptId }}</div>
            <div class="text-xs text-emerald-700/80 mt-1">ยอดรวม {{ selectedFinance.total | number:'1.2-2' }} บาท</div>
          </div>

          <div *ngIf="!selectedFinance && financeOptions.length > 0" class="space-y-2 max-h-48 overflow-y-auto custom-scrollbar">
            <button type="button" *ngFor="let f of financeOptions" (click)="onSelectFinance(f)" [disabled]="isSaving()"
              class="w-full text-left p-3 rounded-xl border text-sm transition-all"
              [ngClass]="isFinanceSelected(f)
                ? 'bg-blue-50 dark:bg-blue-900/30 border-blue-400 ring-2 ring-blue-200'
                : 'bg-white/80 dark:bg-slate-800/80 border-slate-100 dark:border-slate-700 hover:border-blue-300'">
              <div class="font-mono font-bold text-slate-800 dark:text-slate-100">{{ f.receiptId }}</div>
              <div class="text-xs text-slate-500 mt-1">
                ยอด {{ f.total | number:'1.2-2' }} · {{ f.paidDate ? (f.paidDate | date:'dd/MM/yyyy') : 'ไม่ระบุวันชำระ' }}
              </div>
            </button>
          </div>

          <p *ngIf="hasSearchedFinance && !selectedFinance && financeOptions.length === 0 && !isSearchingFinance()"
            class="text-xs text-slate-500 text-center">ไม่พบใบเสร็จ — ลองค้นหาใหม่หรือข้ามขั้นตอนนี้</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex-none px-5 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3">
      <button type="button" (click)="wizardStep() === 1 ? onClose() : prevStep()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        {{ wizardStep() === 1 ? 'ยกเลิก' : 'ย้อนกลับ' }}
      </button>

      <div class="flex flex-col sm:flex-row gap-3 sm:ml-auto">
        <ng-container *ngIf="wizardStep() < wizardSteps.length">
          <button type="button" (click)="nextStep()" [disabled]="isSaving() || !canGoNext"
            class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg transition-colors disabled:opacity-50 flex items-center justify-center gap-1">
            ถัดไป
            <span class="material-icons text-base">arrow_forward</span>
          </button>
        </ng-container>

        <ng-container *ngIf="wizardStep() === wizardSteps.length">
          <button type="button" (click)="onSaveDraft()" [disabled]="!canSave"
            class="px-5 py-2.5 rounded-xl border border-amber-300 dark:border-amber-700 font-bold text-amber-700 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors disabled:opacity-50">
            บันทึก Draft
          </button>
          <button type="button" (click)="onSubmitApproval()" [disabled]="!canSave"
            class="px-5 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg transition-colors disabled:opacity-50">
            ส่งอนุมัติ
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
